module.exports = __webpack_public_path__ + "static/media/slide-or-long.a3282788.svg";